module.exports = __webpack_public_path__ + "img/sair.e2c40353.jpeg";